"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tag = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
var _DeleteIconButton = _interopRequireDefault(require("../Buttons/DeleteIconButton"));
var _Icon = _interopRequireDefault(require("../Icons/Icon"));
var _mixins = require("../mixins");
var _helpers = require("../helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var propTypes = {
  /** Color for the text. Expects a valid color name string from the theme. Defaults to "primary". */
  color: _propTypes["default"].string,
  /** Specify a background color. Expects a valid color name string from the theme. By default the text color is used to derive the background color. */
  backgroundColor: _propTypes["default"].string,
  /** Size variant */
  size: _propTypes["default"].oneOf(["default", "small"]),
  /** Text (content) of the badge is passed as children. */
  children: _propTypes["default"].node,
  /** Apply a text transform like uppercase. */
  textTransform: _propTypes["default"].string,
  /** Font weight for the text. Defaults to "normal" */
  fontWeight: _propTypes["default"].oneOf(["normal", "semibold", "bold"]),
  /** When `true` make the Tag square. Use with caution, it will set a fixed width */
  isSquare: _propTypes["default"].bool
};
var heights = {
  "default": "24px",
  small: "18px"
};
var Icon = (0, _styledComponents["default"])(_Icon["default"]).attrs(function (props) {
  return {
    color: props.color || "currentColor"
  };
}).withConfig({
  displayName: "Tag__Icon",
  componentId: "sc-1owwf63-0"
})(["", ""], function (props) {
  return props.size && (0, _styledComponents.css)(["&&&{font-size:", ";}"], props.theme.iconSizes[props.size] || "s");
});
Icon.displayName = "Tag.Icon";
var Tag = _styledComponents["default"].div.withConfig({
  displayName: "Tag",
  componentId: "sc-1owwf63-1"
})(["display:inline-flex;position:relative;justify-content:center;align-items:center;flex:0 0 auto;gap:", ";padding:0 ", ";height:", ";font-size:", ";line-height:1;border-radius:", ";font-weight:", ";overflow:hidden;", ";background-color:", ";&::before{position:absolute;content:\"\";display:block;width:100%;height:100%;background-color:", ";z-index:", ";}", " ", ";", ";", "{font-size:", ";}", ""], function (props) {
  return (0, _helpers.getSpace)(props, "gap", "xs");
}, function (props) {
  return props.theme.spaces.xs;
}, heights["default"], function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.borderRadius.base;
}, function (props) {
  return props.fontWeight || props.theme.fontWeights.normal;
}, (0, _mixins.colorMixin)("text"), function (props) {
  return (0, _polished.rgba)((0, _helpers.getColor)(props, "color", "text"), 0.2);
}, function (props) {
  return props.theme.colors.backgroundPrimary;
}, function (props) {
  return props.theme.zIndex.below;
}, function (props) {
  return props.backgroundColor && (0, _styledComponents.css)(["", ";"], (0, _mixins.backgroundMixin)("backgroundFourth"));
}, function (props) {
  return props.textTransform && (0, _styledComponents.css)(["text-transform:", ";"], props.textTransform);
}, function (props) {
  return props.isSquare && (0, _styledComponents.css)(["padding:0;width:", ";"], props.size === "small" ? heights.small : heights["default"]);
}, Icon, function (props) {
  return props.theme.iconSizes.s;
}, function (props) {
  return props.size === "small" && (0, _styledComponents.css)(["height:", ";font-size:", ";padding:1px ", " 0;gap:", ";border-radius:", ";", "{font-size:", ";}"], heights.small, props.theme.fontSizes.xs, props.theme.spaces.xxs, function (props) {
    return (0, _helpers.getSpace)(props, "gap", "xxs");
  }, props.theme.borderRadius.s, Icon, function (props) {
    return props.theme.iconSizes.xs;
  });
});
exports.Tag = Tag;
Tag.displayName = "Tag";
Tag.propTypes = propTypes;
var Text = _styledComponents["default"].span.withConfig({
  displayName: "Tag__Text",
  componentId: "sc-1owwf63-2"
})(["display:block;"]);
Text.displayName = "Tag.Text";
var TagDeleteButton = (0, _styledComponents["default"])(_DeleteIconButton["default"]).withConfig({
  displayName: "Tag__TagDeleteButton",
  componentId: "sc-1owwf63-3"
})(["font-size:8px;"]);
var DeleteButton = function DeleteButton(props) {
  return /*#__PURE__*/_react["default"].createElement(TagDeleteButton, _extends({
    iconSize: "inherit",
    w: "12px",
    color: "textSecondary",
    textColor: "textInverted",
    label: "Remove",
    tooltipText: null
  }, props));
};
Tag.Text = Text;
Tag.Icon = Icon;
Tag.DeleteButton = DeleteButton;
var _default = Tag;
exports["default"] = _default;